import CaptchaGenStatTableDto from 'app/admin/captchagenstat/dto/CaptchaGenStatTableDto';
import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';

class CaptchaGenStatTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'captchaGenStatTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<CaptchaGenStatTableDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, CaptchaGenStatTableDto)))
				.catch(reject);
		});
	}
}

export default new CaptchaGenStatTableService();
